import { render, staticRenderFns } from "./RightDetail.vue?vue&type=template&id=4402f619&scoped=true"
import script from "./RightDetail.vue?vue&type=script&lang=js"
export * from "./RightDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4402f619",
  null
  
)

export default component.exports